import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { handlePending, handleRejected } from '../common/extra-reducers/commonExtraReducers';
import { addNewWorkerBioData, editPartnerWorkerBioDataAPI, getPartnerWorkerListAPI, getPartnerWorkerStatusAPI, partnerSendRegLinkAPI, partnerWorkerChangeStatusAPI, partnerWorkerProfileStatusesAPI, saveNewWorkerProcessingData } from '../../../services/partners';
import { fetchPartnerWorkerListFulfilled, handleAddWorkerBioDataFulfilled, handleEditPartnerWorkerBioDataFulfilled, handlePartnerSendRegLinkFulfilled, handlePartnerWorkerChangeStatusFulfilled, handlePartnerWorkerStatusFulfilled, handleSaveWorkerProcessingDataFulfilled, partnerWorkerProfileStatusesFulfilled } from './partnerExtraReducers';

export const fetchPartnerWorkerList = createAsyncThunk('partners/fetchPartnerWorkerList', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await getPartnerWorkerListAPI(reqPayload);
    return response;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const addWorkerBioData = createAsyncThunk('partners/addWorkerBioData', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await addNewWorkerBioData(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});
export const fetchPartnerWorkerStatus = createAsyncThunk('partners/fetchPartnerWorkerStatus', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await getPartnerWorkerStatusAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const partnerWorkerChangeStatus = createAsyncThunk('partners/partnerWorkerChangeStatus', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await partnerWorkerChangeStatusAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const editPartnerWorkerBioData = createAsyncThunk('partners/editPartnerWorkerBioData', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await editPartnerWorkerBioDataAPI(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const saveWorkerProcessingData = createAsyncThunk('partners/saveWorkerProcessingData', async (reqPayload, { rejectWithValue }) => {
  try {
    const response = await saveNewWorkerProcessingData(reqPayload);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

export const partnerWorkerProfileStatuses = createAsyncThunk('partners/partnerWorkerProfileStatuses', async (params, { rejectWithValue }) => {
  try {
    const response = await partnerWorkerProfileStatusesAPI(params);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});
export const partnerSendRegLink = createAsyncThunk('partners/partnerSendRegLink', async (params, { rejectWithValue }) => {
  try {
    const response = await partnerSendRegLinkAPI(params);
    return response.data;
  } catch (error) {
    return rejectWithValue({
      data: error.response || 'An error occurred',
    });
  }
});

const partnerSlice = createSlice({
  name: 'partners',
  initialState: {
    savedWorker: {},
    status: 'success',
    error: null,
    workerProfileStatuses: [],
    partnerWorkers : [], 
    currentPage : 1, 
    perPage : 10, 
    totalPages : 0, 
    totalJobOffers : 0,
    lastUpdated : null, 
    message: '',
    filters: {},
    partnerWorkerStatus: [],
  },
  reducers: {
      setFilters(state, action) {
        state.filters = action.payload; 
      },
      resetFilters(state) {
        state.filters = {limit: 10, page: 1}; 
      },
      setPartnerWorker(state, action) {
        state.savedWorker = action.payload;
      }
    },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPartnerWorkerList.pending, handlePending)
      .addCase(fetchPartnerWorkerList.fulfilled, fetchPartnerWorkerListFulfilled)
      .addCase(fetchPartnerWorkerList.rejected, handleRejected)
      .addCase(partnerWorkerProfileStatuses.pending, handlePending)
      .addCase(partnerWorkerProfileStatuses.fulfilled, partnerWorkerProfileStatusesFulfilled)
      .addCase(partnerWorkerProfileStatuses.rejected, handleRejected)
      .addCase(addWorkerBioData.pending, handlePending)
      .addCase(addWorkerBioData.fulfilled, handleAddWorkerBioDataFulfilled)
      .addCase(addWorkerBioData.rejected, handleRejected)
      .addCase(editPartnerWorkerBioData.pending, handlePending)
      .addCase(editPartnerWorkerBioData.fulfilled, handleEditPartnerWorkerBioDataFulfilled)
      .addCase(editPartnerWorkerBioData.rejected, handleRejected)
      .addCase(saveWorkerProcessingData.pending, handlePending)
      .addCase(saveWorkerProcessingData.fulfilled, handleSaveWorkerProcessingDataFulfilled)
      .addCase(saveWorkerProcessingData.rejected, handleRejected)
      .addCase(partnerSendRegLink.pending, handlePending)
      .addCase(partnerSendRegLink.fulfilled, handlePartnerSendRegLinkFulfilled)
      .addCase(partnerSendRegLink.rejected, handleRejected)
      .addCase(fetchPartnerWorkerStatus.pending, handlePending)
      .addCase(fetchPartnerWorkerStatus.fulfilled, handlePartnerWorkerStatusFulfilled)
      .addCase(fetchPartnerWorkerStatus.rejected, handleRejected)
      .addCase(partnerWorkerChangeStatus.pending, handlePending)
      .addCase(partnerWorkerChangeStatus.fulfilled, handlePartnerWorkerChangeStatusFulfilled)
      .addCase(partnerWorkerChangeStatus.rejected, handleRejected);
  },
});
export const { setFilters, resetFilters, setPartnerWorker } = partnerSlice.actions;

export default partnerSlice.reducer;
